import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const DefensiveMarkdown = ({ children }) => {
  if (!children || typeof children !== 'string') return null;

  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        ul: ({ children }) => (
          <ul
            style={{
              paddingLeft: '1rem',
              margin: '0 0 4px 0',
              listStyleType: 'disc',
            }}
          >
            {children}
          </ul>
        ),
        li: ({ children }) => (
          <li
            style={{
              fontSize: '12.75px',
              color: '#374151',
              marginBottom: '2px',
              lineHeight: '1.4',
            }}
          >
            {children}
          </li>
        ),
        p: ({ children }) => (
          <p
            style={{
              fontSize: '12.75px',
              lineHeight: '1.45',
              margin: '0 0 5px 0',
              color: '#374151',
            }}
          >
            {children}
          </p>
        ),
        strong: ({ children }) => (
          <strong
            style={{
              fontWeight: 600,
              color: '#111827',
            }}
          >
            {children}
          </strong>
        ),
        br: () => <br />,
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default DefensiveMarkdown;
